import { LanguageEnum } from '@/types/schema';

export const LANGUAGE_I18N_MAP: Record<string, string> = {
  English: 'en-US',
  Hindi: 'hi',
  Marathi: 'mr',
  Tamil: 'ta',
  Telugu: 'te',
  Kannada: 'kn',
  Gujarati: 'gu',
  Spanish: 'es',
  Arabic: 'ar',
  Bengali: 'bn',
  Malayalam: 'ml',
  Chinese: 'ch',
  French: 'fr',
};

export const LANGUAGE_I18N_MAP_REVERSE: Record<string, string> = {
  ar: 'ARABIC',
  bn: 'BENGALI',
  ch: 'CHINESE',
  'en-US': 'ENGLISH',
  fr: 'FRENCH',
  hi: 'HINDI',
  mr: 'MARATHI',
  es: 'SPANISH',
  ta: 'TAMIL',
  te: 'TELUGU',
  kn: 'KANNADA',
  gu: 'GUJARATI',
  ml: 'MALAYALAM',
};

export const LANGUAGE_I18N_MAP_WITH_LANG_ENUM: Record<LanguageEnum, string> = {
  [LanguageEnum.English]: 'en-US',
  [LanguageEnum.Hindi]: 'hi',
  [LanguageEnum.Marathi]: 'mr',
  [LanguageEnum.Tamil]: 'ta',
  [LanguageEnum.Telugu]: 'te',
  [LanguageEnum.Kannada]: 'kn',
  [LanguageEnum.Gujarati]: 'gu',
  [LanguageEnum.Spanish]: 'es',
  [LanguageEnum.Arabic]: 'ar',
  [LanguageEnum.Bengali]: 'bn',
  [LanguageEnum.Malayalam]: 'ml',
  [LanguageEnum.Chinese]: 'ch',
  [LanguageEnum.French]: 'fr',
};

export const LANGUAGE_I18N_MAP_WITH_LANG_ENUM_REVERSE: Record<string, LanguageEnum> = {
  'en-US': LanguageEnum.English,
  hi: LanguageEnum.Hindi,
  mr: LanguageEnum.Marathi,
  ta: LanguageEnum.Tamil,
  te: LanguageEnum.Telugu,
  kn: LanguageEnum.Kannada,
  gu: LanguageEnum.Gujarati,
  es: LanguageEnum.Spanish,
  ar: LanguageEnum.Arabic,
  bn: LanguageEnum.Bengali,
  ml: LanguageEnum.Malayalam,
  ch: LanguageEnum.Chinese,
  fr: LanguageEnum.French,
};
